import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type SectionEyebrowProps = {
  children: ReactNode;
  className?: string;
  align?: 'left' | 'center';
};

export function SectionEyebrow({ children, className, align = 'left' }: SectionEyebrowProps) {
  return (
    <p
      className={cn(
        'flex items-center gap-3 font-accent text-sm text-primary',
        align === 'center' && 'justify-center',
        className,
      )}
    >
      <span aria-hidden className="h-px w-6 bg-current opacity-50" />
      {children}
      {align === 'center' ? <span aria-hidden className="h-px w-6 bg-current opacity-50" /> : null}
    </p>
  );
}
